import { render, staticRenderFns } from "./Podium.vue?vue&type=template&id=c5f9561c&scoped=true"
import script from "./Podium.vue?vue&type=script&lang=ts"
export * from "./Podium.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f9561c",
  null
  
)

export default component.exports